export const CDN = "https://nhlfpiauavry9180994.cdn.ntruss.com/";